import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import {
  Box,
  Typography,
  Paper,
  TextField,
  Button,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";

const ReservationChat = ({ reservation, userDetails }) => {
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchMessages = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${import.meta.env.VITE_BACKEND_URL}/reservation/${
          reservation?.id
        }/messages`
      );
      if (response.data.success) {
        setMessages(response.data.data);
      } else {
        setError(response.data.error || "Failed to fetch messages.");
      }
    } catch (err) {
      console.error("Error fetching messages:", err);
      setError("An error occurred while fetching messages.");
    } finally {
      setLoading(false);
    }
  };

  const handleSendMessage = async () => {
    if (!newMessage.trim()) {
       toast.error("Message cannot be empty.");
      return;
    }

    try {
      const payload = {
        sender_user_id: userDetails.id,
        message: newMessage.trim(),
      };

      const response = await axios.post(
        `${import.meta.env.VITE_BACKEND_URL}/reservation/${
          reservation?.id
        }/message`,
        payload
      );

      if (response.data.success) {
        // console.log(userDetails);
        setMessages((prev) => [
          ...prev,
          {
            ...response.data.data,
            sender_name: userDetails.firstName,
          },
        ]);
        setNewMessage("");
      } else {
         toast.error(response.data.error || "Failed to send message.");
      }
    } catch (err) {
      console.error("Error sending message:", err);
       toast.error("An error occurred while sending the message.");
    }
  };

  useEffect(() => {
    fetchMessages();
  }, [reservation]);

  if (loading) {
    return <Typography>Loading messages...</Typography>;
  }

  if (error) {
    return <Typography color="error">{error}</Typography>;
  }

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        Reservation Chat
      </Typography>
      <Paper sx={{ p: 2, mb: 2, maxHeight: 400, overflowY: "auto" }}>
        <List>
          {messages.map((msg) => (
            <ListItem key={msg.id}>
              <ListItemText
                primary={`${msg.sender_name}: ${msg.message}`}
                secondary={new Date(msg.created_at).toLocaleString()}
              />
            </ListItem>
          ))}
        </List>
      </Paper>
      <TextField
        fullWidth
        multiline
        rows={3}
        variant="outlined"
        placeholder="Type your message..."
        value={newMessage}
        onChange={(e) => setNewMessage(e.target.value)}
        sx={{ mb: 2 }}
      />
      <Button
        variant="contained"
        color="primary"
        onClick={handleSendMessage}
        disabled={!newMessage.trim()}
      >
        Send Message
      </Button>
    </Box>
  );
};

export default ReservationChat;
